import { NgModule } from '@angular/core';

import { NgModelChangeDebouncedDirective } from './ng-model-change-debounced.directive';

@NgModule({
    declarations: [NgModelChangeDebouncedDirective],
    exports: [NgModelChangeDebouncedDirective],
})
export class NgModelChangeDebouncedModule {}
